const AUDIO_FILES = [
    {
        url: 'files/2_DeannasCoffeeSpot.mp3',
        cover: 'images/1.jpg',
        title: '1. Coffee Spot',
        artist: [
            'Deanna Dunmyer'
        ]
    },
    {
        url: 'files/3_FourEyes.mp3',
        cover: 'images/1.jpg',
        title: '2. Four Eyes',
        artist: [
            'Deanna Dunmyer'
        ]
    },
    {
        url: 'files/4_DeannasFruitopiaSpot.mp3',
        cover: 'images/1.jpg',
        title: '3. Fruitopia Spot',
        artist: [
            'Deanna Dunmyer'
        ]
    },
    {
        url: 'files/5_DeannasTavisDSpot.mp3',
        cover: 'images/1.jpg',
        title: '4. Tavis D',
        artist: [
            'Deanna Dunmyer'
        ]
    }
];

module.exports = { AUDIO_FILES };